import './src/js/*.js';